import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { stateJson } from "../../../DynamicFormsJson/MastersJSON/state";
import { getRegionNew } from "../../../Slice/region.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { serverMsg, noInternetMsg } from "../../../config/messageconstant";
import AssignStateToSales from "./AssignStateToSales";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { compose } from "@reduxjs/toolkit";
import { withRouter } from "../../../components/withRouter";
import PropTypes from "prop-types";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class StateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
      },
    };
  }

  a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  handledChange = (e, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
  }
  async componentDidMount() {
    const { getRegionNew, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getRegionNew().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onCancel = () => {
    this.props.navigate(-1);
  };

  getFormData = (rowData) => {
    this.setState({ rowData: rowData });
    this.props.navigate(stateJson.formPath + "/" + rowData.data.id);
    this.setState({
      tabValue: 1,
    });
  };
  setDataToForm = (data) => {
    this.setState({ formData: data });
  };

  render() {
    const { dynamicMasterData, tabValue, formData, rowData } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            pt: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={stateJson.screenTitle}
            showTable={false}
            showBackButton={true}
            showAddButton={false}
            onCancel={this.onCancel}
          />
          <Tabs
            onChange={this.handledChange}
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={"Form "} {...this.a11yProps(0)} />

            <Tab label={"Assign State"} {...this.a11yProps(1)} />
          </Tabs>
          <SwipeableViews index={tabValue} onChangeIndex={this.handleChange}>
            <TabPanel value={tabValue} index={0}>
              <DynamicForm
                padding={false}
                paddingTop={false}
                formPath={stateJson.formPath}
                getListById={this.getListById}
                screenTitle={stateJson.screenTitle}
                fieldMeta={stateJson.fieldMeta}
                dynamicMasterData={dynamicMasterData}
                apiBaseURL={stateJson.apiBaseURL}
                showSaveNextBtn={stateJson.showSaveNextBtn}
                isEditURL={stateJson.isEditURL}
                showTitleAndBack={false}
                showSaveBtn={false}
                getFormData={this.getFormData}
                getFormDataStatic={true}
                getDataForm={true}
                setDataToForm={this.setDataToForm}
                isLog={true}
                type={1}
              />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <AssignStateToSales
                padding={false}
                paddingTop={false}
                formPath={stateJson.formPath}
                getListById={this.getListById}
                screenTitle={stateJson.screenTitle}
                fieldMeta={stateJson.fieldMetaForSalesStateAssignation}
                dynamicMasterData={dynamicMasterData}
                apiBaseURL={stateJson.apiBaseURL}
                showSaveNextBtn={stateJson.showSaveNextBtn}
                isEditURL={stateJson.isEditURL}
                showTitleAndBack={false}
                rowData={rowData}
              />
            </TabPanel>
          </SwipeableViews>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  regionList: state.region,
});
const mapDispatchToProps = {
  getRegionNew,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StateForm);
